import { useReframe } from 'nike-re-framejs';
import { matchTicketsBetTickets$$ } from '../subs';

export const useTicketsForBets = betIds => {
    const { derefSub } = useReframe();
    return betIds
        .map(betId => derefSub(matchTicketsBetTickets$$(betId)))
        .filter(val => val != null)
        .flatten(1);
};
